import { Navigate, Route, Routes } from "react-router";
import SigninPage from "./Signin/Index";
import DashBoard from "./Dashboard/Index";
import { dashBoardPaths } from "./Dashboard/routes";
import AnalysisPage from "./Dashboard/Analysis/Index";
import ReviewsPage from "./Dashboard/Reviews/Index";
import SettingPage from "./Dashboard/Settings/Index";
import RequireAuth from "../contexts/AuthProvider";
import { rootPaths } from "./routes";
import { FC } from "react";
import { Page404 } from "./Error/404";
import SelectBranchPage from "./SelectBranch/Index";
import AdminIndexPage from "./Admin/Index";

const Pages: FC = () => (
  <Routes>
    {/* ログイン不要 */}
    <Route path={rootPaths.signin} element={<SigninPage />} />
    <Route path="*" element={<Page404 />} />
    {/* ログインが必要 */}
    <Route path="*" element={<RequireAuth />}>
      <Route index element={<Navigate to={rootPaths.selectBranch} />} />
      <Route path="*" element={<Navigate to={rootPaths.selectBranch} />} />
      <Route path={rootPaths.selectBranch} element={<SelectBranchPage />} />
      {/* FIXME: Dashboard配下でRoutingしたいなぁ */}
      <Route path={rootPaths.dashboard} element={<DashBoard />}>
        <Route index element={<Navigate to={dashBoardPaths.analysis} />} />
        <Route path={dashBoardPaths.analysis} element={<AnalysisPage />} />
        {/* <Route path={dashBoardPaths.customers} element={<CustomersPage />} /> */}
        <Route path={dashBoardPaths.reviews} element={<ReviewsPage />} />
        <Route path={dashBoardPaths.setting} element={<SettingPage />} />
      </Route>
      <Route path={rootPaths.admin} element={<AdminIndexPage />} />
    </Route>
  </Routes>
);
export default Pages;
